import React from "react"
import PointsEditor from "./PointsEditor"
import { isTenis10Event } from "../../../../../tenis10Event"

export default function Points({ match: { params: { id, competitionId } = {} } = {}, getEventDetails, eventDetails, competitionDetails }) {
  // P54 (B3): Tenis10 gives no points in the Sportya rankings
  const tenis10 = isTenis10Event(eventDetails) || Boolean(competitionDetails?.tenis10Level)
  return <PointsEditor key={`${id}:${competitionId}`} eventId={id} competitionId={competitionId} onEventCompleted={getEventDetails} tenis10={tenis10}
    competitions={eventDetails?.competitions} />
}
